module.exports = __webpack_public_path__ + "static/journal-1-0a3458924efc09e2585f83934dc19ba2.png";